module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-book-5ceef6bf70e91cd6e8912e662e0a745e.ttf";